module.exports = __webpack_public_path__ + "img/logo-prisma-simbolo.63e7e023.svg";